import AppSearchPageMixin from "@/protected/mixins/AppSearchPageMixin";
import SearchParametersEditor from "./TagSearchParametersEditor";
import service from "./TagService";

export default {
  mixins: [AppSearchPageMixin],

  components: {
    SearchParametersEditor
  },

  props: {
    columns: {
      default() {
        return [
          {
            key: "label",
            label: this.$t("tag.fields.label"),
            sortBy: "label",
            onClick: ({ row }) => {
              this.$router.push({ name: "Tag", params: { id: row.id } });
            }
          }
          /*
          {
            key: 'lastModified',
            label: this.$t('common.lastModified'),
            sortBy: 'lastModified'
          },
          {
            key: 'lastModifiedOffline',
            label: this.$t('common.lastModifiedOffline')
          }
          */
        ];
      }
    }
  },

  data() {
    return {
      sort: {
        sort: "label",
        order: "ASC"
      }
    };
  },

  methods: {
    getService() {
      return service;
    },

    onAdd() {
      this.$router.push({ name: "Tag", params: { id: "new" } });
    }
  }
};
